import i18n from 'simple-react-i18n'
import { isNil } from 'lodash'

// Un événement affiché sur un RPQS vient soit du RPQS annuel (tables rpqs_evenements /
// rpqs_eg_evenements), soit du référentiel (collectivité / entité de gestion, sans année).
export const EVENT_ORIGIN = {
    RPQS: 'rpqs',
    REFERENTIAL: 'referential',
}

// Type d'événement RPQS (filtre et icône) : déduit des champs de l'événement.
export const EVENT_SOURCE = {
    RPQS: 'rpqs',
    COLLECTIVITY: 'collectivity',
    MANAGEMENT_UNIT: 'managementUnit',
}

// Icônes Material reprises du menu principal (RPQS) et des référentiels RPQS (collectivités, entités de gestion).
export const EVENT_SOURCE_ICONS = {
    [EVENT_SOURCE.RPQS]: 'article',
    [EVENT_SOURCE.COLLECTIVITY]: 'people',
    [EVENT_SOURCE.MANAGEMENT_UNIT]: 'build',
}

export const getEventSourceOptions = () => [
    { id: EVENT_SOURCE.RPQS, name: i18n.rpqs },
    { id: EVENT_SOURCE.COLLECTIVITY, name: i18n.collectivity },
    { id: EVENT_SOURCE.MANAGEMENT_UNIT, name: i18n.managementEntity },
]

// Seul un événement de RPQS porte une année.
export const getEventSource = event => {
    if (!isNil(event.year)) return EVENT_SOURCE.RPQS
    return isNil(event.managementUnitId) ? EVENT_SOURCE.COLLECTIVITY : EVENT_SOURCE.MANAGEMENT_UNIT
}

export const getEventKey = event => `${event.origin}-${event.collectivityId ?? ''}-${event.managementUnitId ?? ''}-${event.number}`

export const getEventOriginLabel = (event, managementUnits = [], collectivity, rpqs) => {
    const managementUnitName = managementUnits.find(m => m.id === event.managementUnitId)?.name ?? event.managementUnitId
    if (event.origin === EVENT_ORIGIN.REFERENTIAL) {
        return isNil(event.managementUnitId) ? `${i18n.collectivity} - ${collectivity?.name ?? ''}` : `${i18n.managementEntity} - ${managementUnitName}`
    }
    const rpqsLabel = `${i18n.rpqs} ${event.year} - ${rpqs?.name ?? ''}`
    return isNil(event.managementUnitId) ? rpqsLabel : `${rpqsLabel} - ${managementUnitName}`
}
